import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider,
  Stepper,
  Step,
  StepLabel,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";

import BasicInfoSection from "./components/BasicInfoSection";
import ExperienceSection from "./components/ExperienceSection";
import EducationSection from "./components/EducationSection";
import LanguageSection from "./components/LanguageSection";
import CertificateSection from "./components/CertificateSection";

import api from "../../services/api";

const tabSteps = [
  "Basic Info",
  "Experience",
  "Education",
  "Languages",
  "Certificates",
];

function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ pt: 2 }}>{children}</Box> : null;
}

export default function EditCandidateForm() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [form, setForm] = useState(null);

  useEffect(() => {
  const fetchCandidate = async () => {
  try {
    const { data } = await api.get(`/recruiter/candidates/${id}`);
    console.log("🎯 API Candidate Response:", data); // Add this

    const candidate = data?.data || {};

    setForm({
      ...candidate,
      experiences: candidate.experiences ?? [],
      educations: candidate.educations ?? [],
      certificates: candidate.certificates ?? [],
      language_skills: candidate.language_skills ?? [],
    });
  } catch (err) {
    console.error(err);
    setError("❌ Failed to load candidate.");
  } finally {
    setLoading(false);
  }
};


    fetchCandidate();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      await api.put(`/recruiter/candidates/${id}`, form);
      alert("✅ Candidate updated successfully!");
      navigate("/recruiter/candidates");
    } catch (err) {
      console.error(err);
      setError("❌ Failed to update candidate.");
    }
  };

  const handleNext = () => {
    if (tabIndex < tabSteps.length - 1) setTabIndex(tabIndex + 1);
  };

  const handleBack = () => {
    if (tabIndex > 0) setTabIndex(tabIndex - 1);
  };

  if (loading || !form) {
    return (
      <Box p={4} textAlign="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1000, mx: "auto", my: 4 }}>
      <Paper elevation={4} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom>
          Edit Candidate
        </Typography>

        <Stepper activeStep={tabIndex} alternativeLabel sx={{ mb: 3 }}>
          {tabSteps.map((label, index) => (
            <Step key={index}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TabPanel value={tabIndex} index={0}>
            <BasicInfoSection form={form} setForm={setForm} />
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <ExperienceSection form={form} setForm={setForm} />
          </TabPanel>
          <TabPanel value={tabIndex} index={2}>
            <EducationSection form={form} setForm={setForm} />
          </TabPanel>
          <TabPanel value={tabIndex} index={3}>
            <LanguageSection form={form} setForm={setForm} />
          </TabPanel>
          <TabPanel value={tabIndex} index={4}>
            <CertificateSection form={form} setForm={setForm} />
          </TabPanel>

          <Divider sx={{ mt: 4, mb: 2 }} />

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Button variant="outlined" onClick={handleBack} disabled={tabIndex === 0}>
              Back
            </Button>
            {tabIndex < tabSteps.length - 1 ? (
              <Button variant="contained" onClick={handleNext}>
                Next
              </Button>
            ) : (
              <Button type="submit" variant="contained" color="primary">
                Update Candidate
              </Button>
            )}
          </Box>
        </form>
      </Paper>
    </Box>
  );
}
